import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { trpc, useTRPC } from "../../../shared/api/trpc";

export type TreeAccessSummary = Awaited<ReturnType<typeof trpc.access.treeSummaries.query>>[number];

export function treeAccessKey(scopeType: TreeAccessSummary["scopeType"], scopeId: string) {
  return `${scopeType}:${scopeId}`;
}

export function useTreeAccessSummaries() {
  const trpc = useTRPC();
  const summariesQuery = useQuery(trpc.access.treeSummaries.queryOptions());

  const reload = useCallback(async () => {
    try {
      await summariesQuery.refetch();
    } catch {
      // Indicators are decorative; a failed refresh must not break the tree.
    }
  }, [summariesQuery.refetch]);

  const byScope = useMemo(() => {
    const map = new Map<string, TreeAccessSummary>();
    for (const summary of summariesQuery.data ?? []) {
      map.set(treeAccessKey(summary.scopeType, summary.scopeId), summary);
    }
    return map;
  }, [summariesQuery.data]);

  return { byScope, reload };
}
